import { AVAILABLE_PAGES_ENUM, PAGES_ENUM } from 'routes/enums';
import { RouteMapType } from 'routes/routeGroupMaps/types';

const map: RouteMapType = new Map([[AVAILABLE_PAGES_ENUM.USER_EDIT, PAGES_ENUM.DASHBOARD]]);

export default map;
